import ButtonComponent from '../../Button'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import styles from './inner-table.module.scss'
import { useNavigate } from 'react-router-dom'

const ParticipantsCell = ({ survey, participants, participantsTerminated, setFontColor, setSelectedSurvey }) => {
  const i18n = useTranslation()
  const navigate = useNavigate()
  if (!participants || participants.length === 0) return <div className={styles.responses_cell_wrapper}>--</div>

  if (!survey) {
    return (
      <div className={styles.responses_cell_wrapper}>
        {i18n.t('pages.data.sociogram.activeSociogramEce.noSurveyMessage')}
      </div>
    )
  }

  const { id: surveyId, isActive, isDone, results } = survey

  const handleViewCourseList = (survey) => {
    const surveyId = survey.id || null
    navigate(`/sociogram/students-list/${surveyId}`)
    setSelectedSurvey(surveyId ? survey : null)
  }

  return (
    <div className={styles.responses_cell_wrapper} data-testid='surveyParticipantsCell'>
      <span
        style={{
          color: setFontColor(isActive, isDone, results),
          fontWeight: 'bold'
        }}
        className={styles.responses_text}
      >
        <span>{i18n.t('pages.data.sociogram.activeSociogramEce.table.responsesText')}</span>
        <div>{`${typeof participantsTerminated === 'number' ? participantsTerminated : '--'} / ${participants.length}`}</div>
      </span>
      <ButtonComponent
        buttonText={`${i18n.t('pages.data.sociogram.activeSociogramEce.table.listButton')}`}
        colorType='primary'
        icon={<FontAwesomeIcon icon={faMagnifyingGlass} />}
        size='small'
        bold={false}
        onClick={() => {
          handleViewCourseList(survey)
        }}
        hideTextInMobile
        disabled={!surveyId}
      />
    </div>
  )
}

export default ParticipantsCell
